// extracted by mini-css-extract-plugin
module.exports = {"tabHeading":"BosPendingPage_tabHeading__2U-F3","container":"BosPendingPage_container__1pHoS"};